import {Layout} from "../../../src/ts/layouts/Layout";

export class DeeplinkNavigation extends Layout {

    private readonly STATE_SELECTED: string = 'selected';

    private readonly SELECTOR_NAV_LINKS: string = '.deeplink-navigation__nav-links';
    private readonly SELECTOR_SECTION_LINK: string = '.deeplink-navigation__nav-section-selector-link';


    constructor($elem: JQuery) {
        super($elem);

        this.$layout.find(this.SELECTOR_SECTION_LINK).on('click', (e) => this.onSectionClick(e));
    }

    private onSectionClick(event: JQuery.ClickEvent) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.$layout.find(this.SELECTOR_SECTION_LINK).removeClass(this.STATE_SELECTED);
        $(event.target).addClass(this.STATE_SELECTED);
        this.$layout.find(this.SELECTOR_NAV_LINKS).hide();
        this.$layout.find($(event.target).attr('href')).show();
        return false;
    }
}

